<template>
  <div class="login_container">
    <div class="login_content">
      <div class="logo_div">
        <img :src="bosumLogo" alt="logo">
      </div>
      <h3>登录</h3>
      <p>验证您的身份信息</p>
      <div class="login_form_div">
        <div class="inner">
          <span>+86</span>
          <el-input v-model="myMobile"></el-input>
        </div>
      </div>
    </div>
    <div class="login_bottom">
      <button @click="loginFun">立即评价</button>
    </div>
  </div>
</template>

<script>
  import bosumLogo from '@/assets/bosum-logo.png'
  import Common from "@/utils/common";
  import {getUrlParam} from "@/utils/utils";
  import customerService from '@/api/customerService'
  export default {
    name: "contactEvaluateLogin",
    data: function () {
      return {
        bosumLogo,
        trackId:'',
        myMobile: ''
      }
    },
    mounted() {
      var vm = this;
      document.title = '登录';
      vm.trackId = getUrlParam('trackId');
      console.log(vm.trackId);
    },
    methods: {
      loginFun: function () {
        var vm = this;
        if (Common.Util.isEmpty(vm.myMobile)) {
          Common.PageOperator.showPromptMsg(vm, true, '请填写手机号码', 'warning');
          return;
        }
        if (!Common.Util.isMobile(vm.myMobile)) {
          Common.PageOperator.showPromptMsg(vm, true, '手机号码格式错误，请重新填写', 'warning');
          return;
        }
        customerService.checkMobile(vm, vm.trackId, vm.myMobile).then(function (data) {
          vm.$router.push({path:'/evaluate',query:{trackId:vm.trackId,mobile:vm.myMobile}});
        });
      },
    },
  }
</script>

<style scoped>
  .login_container {
    padding: 50px 30px 0;
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow-y:auto;
    overflow-x:hidden;
  }

  .login_content {

  }

  .login_content > h3 {
    letter-spacing: 1px;
    font-size: 24px;
    margin-bottom: 15px;
    font-weight: normal;
    color: #000;
  }

  .login_content > p {
    font-size: 18px;
    margin-bottom: 20px
  }

  .logo_div {
    margin-bottom: 10px;
  }

  .logo_div > img {
    width: 160px;
  }

  .login_form_div {
    width: 100%;
    height: 50px;
    background: #FFFFFF;
    box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.06);
  }

  .login_form_div > .inner {
    border-bottom: 1px solid #eee;
    margin: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
  }

  .login_form_div > .inner > span {
    border-right: 1px solid #eee;
    width: 50px;
    display: inline-block;
    text-align: center;
    height: 28px;
    line-height: 28px;
  }

  .login_bottom {
    width: 100%;
    padding: 100px 0 30px;
  }

  .login_bottom > button {
    width: 100%;
    height: 46px;
    background: #D43D3D;
    color: #fff;
    font-size: 18px;
    box-shadow: 0px 5px 6px 0px rgba(212, 61, 61, 0.6);
    border: none;
    border-radius: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/views/contactEvaluateLogin.vue